import Object3d from './Object3d';
import Camera from './Camera';
import * as vec3 from "./glMatrix/vec3";

class Light extends Object3d {

	constructor(options={}) {


		options = Object.assign({},{
			type: 'spotlight',// || arealight [TODO: pointlight && directionalLight]
			size: 1,
			color:      [1,1,1],
			direction:  [-1,-1,0],
			position:   [1,1,1],
			intensity:  1,
			distance:   100,
			decay:      1,
			angle:      Math.PI/4,
			exponent:   1,
			castShadow: false,
			penumbra:   0,
			lookAt:     vec3.create(),
			shadowMap:      true,
			// shadowMapWidth:  256,
			// shadowMapHeight: 256,
			width: 0,
			height: 0,

			
			left:   1000,
			right:  1000,
			top:    1000,
			bottom: 1000,

			/** 
			 * maxCameraAngle:
			 * avoid using too large angle for shadow map to avoid perspective aliasing
			 * (very low precision on object near the light)
			 */
			 maxCameraAngle: 0.9 * Math.PI/2,
		}, options)

		super(options)

		this.static = true;//dont re-update light after first call

		this.maxCameraAngle = options.maxCameraAngle
		
		this.type = options.type;
		this.size = 1;
		this.color      = options.color;
		this.intensity  = options.intensity;
		this.position   = options.position;
		this.distance   = options.distance;
		this.decay      = options.decay;
		this.angle      = options.angle;
		this.exponent   = options.exponent;
		this.penumbra   = options.penumbra;
		this.castShadow = options.castShadow;

		this.left   = options.left 
		this.right  = options.right 
		this.top    = options.top 
		this.bottom = options.bottom 
		this.near   = options.near 

		// this.lookAt     = options.lookAt;
		this.width   = options.width;
		this.height  = options.height;

		if (options.shadowMap) {

			this.shadowMap = true;
			this._cachedAngle = this.angle;
			this._cachedDistance = this.distance

			if (this.type == 'directionallight') {
				this.shadowMapCamera = new Camera({
					near:    this.near,
					far:     this.distance,
					left:    this.left,//0.04 * this.distance,
					right:   this.right,//0.04 * this.distance,
					top:     this.top,//0.04 * this.distance,
					bottom:  this.bottom,//0.04 * this.distance,
					type:   'orthographic',
					fov:     45,//( 2 * 0.5*Math.PI ) * 180 / Math.PI,
					orbitControl: false,
					firstPerson: false,
					frustum: true,
					lookAt: [0,0,0],
				});
				this.shadowMapCamera.lookAt = vec3.create()
				vec3.set(this.shadowMapCamera.lookAt, 0, 0, 0);
			}
			else {
				this.shadowMapCamera = new Camera({
					near:    this.near,
					far:     this.distance,
					type:   'perspective',
					fov:   ( 2 * Math.min(this.maxCameraAngle, this.angle) ) * 180 / Math.PI,
					aspect: 1,
					orbitControl: false,
					firstPerson:  false,
					frustum:      true,
				});
				this.shadowMapCenterCamera = new Camera({
					near:    1,
					far:     1500,
					type:   'perspective',
					fov:     ( 2 * Math.PI/2 * 0.6 ) * 180 / Math.PI,//0.5 * 180 / Math.PI,
					aspect: 1,
					orbitControl: false,
					firstPerson:  false,
					frustum:      true,
				});
			}
		}

	}

	update() {

		if (!this.static || !this.hasUpdatedOnce) {
			this.updateMatrix();
			this.updateWorldMatrix();
		}

		if (this.shadowMap) {
				
			if (this._cachedAngle !== this.angle) {
				this._cachedAngle = this.angle;
				this.shadowMapCamera.fov =  ( 2 * Math.min(this.maxCameraAngle, this.angle) ) * 180 / Math.PI;
				this.shadowMapCamera.updateProjectionMatrix()
				if (this.shadowMapCenterCamera) {
					this.shadowMapCenterCamera.updateProjectionMatrix()
				}
			}
			if (this._cachedDistance !== this.distance) {
				this._cachedDistance = this.distance;
				// this.shadowMapCamera.far       = this.distance;
				// this.shadowMapCamera.left =    -this.distance/3;
				// this.shadowMapCamera.right =   this.distance/3;
				// this.shadowMapCamera.top =     this.distance/3;
				// this.shadowMapCamera.bottom =     -this.distance/2;
				this.shadowMapCamera.updateProjectionMatrix()
				if (this.shadowMapCenterCamera) {
					this.shadowMapCenterCamera.far = this.distance;
					this.shadowMapCenterCamera.updateProjectionMatrix()
				}
			}
			
			//TODO: make the camera a child of the light object
			//      instead of copy all props
			this.shadowMapCamera.position[0] = this.worldMatrix[12];
			this.shadowMapCamera.position[1] = this.worldMatrix[13];
			this.shadowMapCamera.position[2] = this.worldMatrix[14];

			if (this.type != 'directionallight') {
				this.shadowMapCamera.rotation[0] = this.rotation[0];
				this.shadowMapCamera.rotation[1] = this.rotation[1];
				this.shadowMapCamera.rotation[2] = this.rotation[2];
			}
			
			if (!this.static || !this.hasUpdatedOnce) {
				this.shadowMapCamera.update()
			}

			if (this.shadowMapCenterCamera) {
				this.shadowMapCenterCamera.position[0] = this.worldMatrix[12];
				this.shadowMapCenterCamera.position[1] = this.worldMatrix[13];
				this.shadowMapCenterCamera.position[2] = this.worldMatrix[14];
				if (this.type != 'directionallight') {
					this.shadowMapCenterCamera.rotation[0] = this.rotation[0];
					this.shadowMapCenterCamera.rotation[1] = this.rotation[1];
					this.shadowMapCenterCamera.rotation[2] = this.rotation[2];
				}
				if (!this.static || !this.hasUpdatedOnce) {
					this.shadowMapCenterCamera.update()
				}
			}

			this.hasUpdatedOnce = true

		
		}

	}


}

export default Light;